import React from 'react';
import { formatDecimals, formatNumber } from '../../utils';
import { Flexbox, FlexboxColumn } from '../action/Flexbox';
import ThemedText from '../theme/ThemedText';
import ThemeLogo from '../theme/ThemeLogo';
import './UserReputation.scss';

const UserReputation = ({ data, filter, onChange }) => {
  // const [showMore, setShowMore] = useState(false);
  // const expandableRef = useRef(null);

  // const handleShowMore = () => {
  //   setShowMore(!showMore);
  // };

  function handleClick(value) {
    if (filter === value) return onChange(null);
    onChange(value);
  }

  return (
    <FlexboxColumn fw>
      <Flexbox fw className='userReputation_wrapper'>
        <Flexbox fw gap='1rem' justifyContent='flex-start'>
          <Flexbox gap='0.75rem' className={`userReputation_wrapper__${!filter ? 'active' : 'each'} hover`} justifyContent='flex-start' onClick={() => handleClick(null)}>
            <ThemeLogo icon={'total'} />
            <div>
              <ThemedText.P>Total</ThemedText.P>
              <Flexbox gap='0.25rem'>
                <ThemedText.H5 weight='semi-bold'>${formatNumber(formatDecimals(+data?.swap?.volume + +data?.bridge?.volume))} </ThemedText.H5>
                <ThemedText.P>Volume</ThemedText.P>
              </Flexbox>
            </div>
          </Flexbox>

          <Flexbox
            gap='0.75rem'
            className={`userReputation_wrapper__${filter === 'swap' ? 'active' : 'each'} hover`}
            justifyContent='flex-start'
            onClick={() => handleClick('swap')}
          >
            <ThemeLogo icon={'swap'} />
            <div>
              <ThemedText.P>Swap</ThemedText.P>
              <Flexbox gap='0.25rem'>
                <ThemedText.H5 weight='semi-bold'>${formatNumber(formatDecimals(data?.swap?.volume))} </ThemedText.H5>
                <ThemedText.P>Volume</ThemedText.P>
              </Flexbox>
            </div>
          </Flexbox>
          <Flexbox
            gap='0.75rem'
            className={`userReputation_wrapper__${filter === 'bridge' ? 'active' : 'each'} hover`}
            justifyContent='flex-start'
            onClick={() => handleClick('bridge')}
          >
            <ThemeLogo icon={'bridge'} />
            <div>
              <ThemedText.P>Bridge</ThemedText.P>
              <Flexbox gap='0.25rem'>
                <ThemedText.H5 weight='semi-bold'>${formatNumber(formatDecimals(data?.bridge?.volume))} </ThemedText.H5>
                <ThemedText.P>Volume</ThemedText.P>
              </Flexbox>
            </div>
          </Flexbox>
          <Flexbox gap='0.75rem' className={`userReputation_wrapper__${filter === 'stake' ? 'active' : 'each'}`} justifyContent='flex-start'>
            <ThemeLogo icon={'stake'} />
            <div>
              <ThemedText.P>Stake</ThemedText.P>
              <Flexbox gap='0.25rem'>
                {/* <ThemedText.H5 weight='semi-bold'>${formatNumber(formatDecimals(data?.bridge?.volume))} </ThemedText.H5> */}
                <ThemedText.P>Coming soon</ThemedText.P>
              </Flexbox>
            </div>
          </Flexbox>
        </Flexbox>

        {/* <Flexbox className='userReputation_wrapper__action'>
          <ThemeLogo onClick={handleShowMore} icon={showMore ? 'blueArrowUp' : 'moreElement'} className='pointer' />
        </Flexbox> */}
      </Flexbox>

      {/* <div
        ref={expandableRef}
        className='userReputation_expandable'
        style={{
          maxHeight: showMore ? `${expandableRef.current?.scrollHeight}px` : '0px',
        }}
      >
        <Flexbox fw className='userReputation_wrapper'>
          <Flexbox fw gap='1.5rem'>
            {data.map(item => (
              <Flexbox gap='0.75rem' className='userReputation_wrapper__each' justifyContent='flex-start'>
                <ThemeLogo icon={'buyCrypto'} />
                <div>
                  <ThemedText.P>{item?.heading}</ThemedText.P>
                  <Flexbox gap='0.25rem'>
                    <ThemedText.H5 weight='semi-bold'>${item?.value} </ThemedText.H5>
                    <ThemedText.P>{item?.prefix}</ThemedText.P>
                  </Flexbox>
                </div>
              </Flexbox>
            ))}
          </Flexbox>
          <Flexbox className='userReputation_wrapper__action'></Flexbox>
        </Flexbox>
      </div> */}
    </FlexboxColumn>
  );
};

export default UserReputation;
